<template>
    <div v-if="!isTicketed" class="mt-4 mb-2 is-size-6 notification is-success">
        This reservation has not yet been ticketed by the
        airline and is eligible for immediate cancellation
        prior to ticketing.
    </div>
    <div v-else-if="isTicketed && isVoidable(tst.ticketNumber)" class="mt-4 mb-2 is-size-6 notification is-warning">
        <ul>
            <li>
                To receive a full refund for your flight, you
                must
                cancel within 24 hours of booking.
            </li>
            <li>
                {{ $helpers.getAirlineName(tst.airlineCode) }}
                will refund your original form of payment within
                7-10
                days.
            </li>
            <li>
                Your refund will include only the fare purchased
                through Trip Circuit. If you made any additional
                purchases from the airline, please contact the
                airline
                directly.
            </li>
        </ul>
    </div>
    <div v-else-if="isTicketed && !isVoidable(tst.ticketNumber)" class="mt-4 mb-2 is-size-6 notification is-warning">
        <ul>
            <li>
                Most flights are refundable for up to 24 hours
                from the initial purchase.
            </li>
            <li>
                Flights cancelled after 24 hours may be eligible
                for credit towards a future flight, minus any fees and
                penalties charged by the airline.
            </li>
        </ul>
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "CancelAirNotification",
    props: {
        tst: {
            type: Object,
            required: true,
        },
        tickets: {
            required: false,
            default: null,
        }
    },
    computed: {
        isTicketed() {
            return this.tst.ticketNumber ? true : false;
        },

    },
    methods: {
        isVoidable(ticketNumber) {
            if (ticketNumber) {
                let now = moment();
                let expirationDate = this.ticketExpire(ticketNumber);

                if (expirationDate && expirationDate.isAfter(now)) return true;
                else return false;
            }
        },
        ticketExpire(ticketNumber){
            if(this.tickets){
                const ticket = this.tickets.find(ticket => ticket.ticketNumber === ticketNumber);
                const voidDeadline = ticket.voidDeadline;
                return moment(voidDeadline);
            }
            return null;
        }
    }
};
</script>

<style></style>